/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */

'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message"];
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getShouldDisplayImageProcessingBannerById } from '../../email-inline-images/selectors/getShouldDisplayImageProcessingBanner';
import { getInlineImagePendingIds } from 'conversations-message-history/common-message-format/operators/getInlineImagePendingIds';
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { toJSTyped } from 'conversations-thread-data/utils/immutable/toJSTyped';
import { fetchImageProcessingStatusById } from '../../email-inline-images/actions/fetchImageProcessingStatusById';
import { jsx as _jsx } from "react/jsx-runtime";
export const withInlineImageStatusValidator = WrappedComponent => props => {
  const {
      message
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const dispatch = useDispatch();
  const {
    numberOfProcessingImages,
    shouldDisplayBanner
  } = useSelector(getShouldDisplayImageProcessingBannerById(getId(message)));
  const handleFetchImageProcessingStatus = useCallback(() => {
    dispatch(fetchImageProcessingStatusById({
      fileIds: toJSTyped(getInlineImagePendingIds(message)),
      messageId: getId(message)
    }));
  }, [dispatch, message]);
  const inlineImageStatusProps = {
    numberOfProcessingImages,
    shouldDisplayBanner,
    handleFetchImageProcessingStatus
  };
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({
    message: message
  }, inlineImageStatusProps, rest));
};